import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template8 = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-white min-h-screen font-sans">
            <header className="bg-stone-200 p-4 relative z-10">
                <div className="container mx-auto flex justify-between items-center">
                    <button
                        onClick={() => navigate('/TemplateThemes')}
                        className="flex items-center gap-2 px-4 py-2 bg-stone-300 text-stone-700 rounded-lg hover:bg-stone-400 transition-colors"
                    >
                        <ArrowLeft size={18} /> Back to Templates
                    </button>
                    <h1 className="text-3xl font-serif text-stone-800">Vintage Charm</h1>
                    <div className="w-24"></div> {/* Placeholder for alignment */}
                </div>
            </header>
            
            {/* Hero Section - Replicated from DesignerPage8 */}
            <div className="relative flex flex-col lg:flex-row items-center justify-center min-h-screen bg-stone-50 text-stone-800 p-8 lg:p-12">
                <div className="absolute inset-0 bg-grid-stone-200 [mask-image:linear-gradient(to_bottom,white,transparent)]"></div>
                <div className="relative z-10 w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left mb-12 lg:mb-0">
                    <h1 className="text-5xl md:text-7xl font-serif tracking-tight">Vintage Charm</h1>
                    <p className="mt-6 text-lg max-w-lg text-stone-600">
                        An exclusive collection of finely crafted designs, where tradition meets contemporary elegance.
                    </p>
                    <a href="#" className="mt-8 inline-block bg-stone-800 text-white font-semibold py-3 px-8 rounded-full hover:bg-stone-900 transition-colors duration-300">
                        Explore The Collection
                    </a>
                </div>
                <div className="relative z-10 w-full md:w-3/4 lg:w-1/2 h-[60vh] lg:h-[70vh]">
                    <div className="relative h-full w-full shadow-2xl rounded-lg overflow-hidden">
                        <img 
                            src="https://placehold.co/1200x800/D4B8A5/523A28?text=Vintage+Collection"
                            alt="Hero Image" 
                            className="absolute w-full h-full object-cover" 
                        />
                        <div className="absolute inset-0 bg-black/10"></div>
                    </div>
                </div>
            </div>

            {/* About Section - Replicated from DesignerPage8 */}
            <div className="bg-white py-24 sm:py-32">
                <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
                    <p className="text-base font-semibold leading-7 text-amber-600">The Vision</p>
                    <h2 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">
                        Crafting Tomorrow's Heirlooms
                    </h2>
                    <p className="mt-6 text-lg leading-8 text-stone-600">
                        Inspired by the rich history of fashion, our designs blend timeless silhouettes with modern details. We believe in creating pieces that are not just clothes, but cherished memories waiting to be made.
                    </p>
                </div>
            </div>

            {/* Featured Collections Section - Replicated from DesignerPage8 */}
            <div className="bg-stone-50 py-24 sm:py-32">
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="max-w-2xl mx-auto text-center mb-16">
                        <h2 className="text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Shop By Category</h2>
                        <p className="mt-4 text-lg text-stone-600">
                            Discover curated selections from our latest lookbooks and signature lines.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
                        {[1, 2, 3, 4].map((id, index) => (
                            <div key={index} className="block group">
                                <div className="overflow-hidden rounded-lg bg-stone-100 shadow-lg">
                                    <img src={`https://placehold.co/400x500/D0B8A5/523A28?text=Collection+${id}`} alt={`Collection ${id}`} className="w-full object-cover aspect-[4/5] group-hover:scale-105 transition-transform duration-500 ease-in-out" />
                                </div>
                                <h3 className="mt-4 text-xl font-semibold text-stone-800">Collection Name {id}</h3>
                                <p className="mt-1 text-base text-stone-500">Curated styles for you.</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Product Gallery Section - Replicated from DesignerPage8 */}
            <main id="product-gallery" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">
                        The Full Collection
                    </h2>
                    <p className="mt-4 max-w-2xl mx-auto text-lg text-stone-600">
                        Browse the complete catalog of available designs.
                    </p>
                </div>
                
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(id => (
                        <div key={id} className="bg-gray-50 p-4 rounded-lg shadow-sm">
                            <img src={`https://placehold.co/400x500/E0E0E0/333333?text=Product+${id}`} alt={`Product ${id}`} className="w-full h-64 object-cover rounded-md mb-4" />
                            <h3 className="font-semibold text-gray-800 text-lg">Product Title {id}</h3>
                            <p className="text-gray-600 mt-1">$XX.XX</p>
                            <button className="mt-3 w-full px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors">Add to Cart</button>
                        </div>
                    ))}
                </div>
            </main>

            <footer className="bg-stone-800 text-white text-center p-6 mt-8">
                <p>&copy; 2025 Vintage Charm. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Template8;